<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 149"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>tech-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-1197.000000, -438.000000)">
        <g
          id="tech-enthusiasts"
          transform="translate(1198.000000, 438.000000)">
          <g id="New_Symbol_83-3">
            <path
              id="Path"
              d="M170.818215,81.8181818 C170.815052,48.4048854 150.49458,18.3508104 119.487669,5.90011177 C88.480759,-6.55058691 53.0184679,1.10414626 29.9081796,25.2363439 C6.79789129,49.3685415 0.683780904,85.1286685 14.4636364,115.568182 L163.536364,115.568182 C168.345764,104.967218 170.828731,93.459086 170.818215,81.8181818 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="9.22727273"
              y1="115.568182"
              x2="168.772727"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="0.0227272727"
              y1="115.568182"
              x2="5.13636364"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="172.863636"
              y1="115.568182"
              x2="177.977273"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="81.8409091"
            y="80.7954545"
            width="69.5454545"
            height="6.13636364"
            rx="1.02272727" />
          <rect
            id="Rectangle"
            class="fill-white"
            fill-rule="nonzero"
            x="85.9318182"
            y="86.9318182"
            width="4.09090909"
            height="28.6363636" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="85.9318182"
            y="86.9318182"
            width="4.09090909"
            height="28.6363636" />
          <rect
            id="Rectangle"
            class="fill-white"
            fill-rule="nonzero"
            x="143.204545"
            y="86.9318182"
            width="4.09090909"
            height="28.6363636" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="143.204545"
            y="86.9318182"
            width="4.09090909"
            height="28.6363636" />
          <path
            id="Path"
            d="M124.795455,93.0681818 C124.795455,91.9385085 125.711236,91.0227273 126.840909,91.0227273 L137.068182,91.0227273 C138.197855,91.0227273 139.113636,91.9385085 139.113636,93.0681818 L139.113636,115.568182 L124.795455,115.568182 L124.795455,93.0681818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="128.886364"
            y1="95.1136364"
            x2="135.022727"
            y2="95.1136364"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="128.886364"
            y1="99.2045455"
            x2="135.022727"
            y2="99.2045455"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M128.886364,102.272727 C128.321527,102.272727 127.863636,102.730618 127.863636,103.295455 C127.863636,103.860291 128.321527,104.318182 128.886364,104.318182 C129.4512,104.318182 129.909091,103.860291 129.909091,103.295455 C129.909091,102.730618 129.4512,102.272727 128.886364,102.272727 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M135.022727,102.272727 C134.457891,102.272727 134,102.730618 134,103.295455 C134,103.860291 134.457891,104.318182 135.022727,104.318182 C135.587564,104.318182 136.045455,103.860291 136.045455,103.295455 C136.045455,102.730618 135.587564,102.272727 135.022727,102.272727 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M135.022727,50.1136364 L145.25,50.1136364 C146.379673,50.1136364 147.295455,51.0294176 147.295455,52.1590909 L147.295455,80.7954545 L132.977273,80.7954545 L132.977273,52.1590909 C132.977273,51.0294176 133.893054,50.1136364 135.022727,50.1136364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="137.068182"
            y1="54.2045455"
            x2="143.204545"
            y2="54.2045455"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="137.068182"
            y1="58.2954545"
            x2="143.204545"
            y2="58.2954545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M137.068182,61.3636364 C136.503345,61.3636364 136.045455,61.821527 136.045455,62.3863636 C136.045455,62.9512003 136.503345,63.4090909 137.068182,63.4090909 C137.633018,63.4090909 138.090909,62.9512003 138.090909,62.3863636 C138.090909,61.821527 137.633018,61.3636364 137.068182,61.3636364 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M143.204545,61.3636364 C142.639709,61.3636364 142.181818,61.821527 142.181818,62.3863636 C142.181818,62.9512003 142.639709,63.4090909 143.204545,63.4090909 C143.769382,63.4090909 144.227273,62.9512003 144.227273,62.3863636 C144.227273,61.821527 143.769382,61.3636364 143.204545,61.3636364 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M137.068182,65.4545455 C136.503345,65.4545455 136.045455,65.9124361 136.045455,66.4772727 C136.045455,67.0421094 136.503345,67.5 137.068182,67.5 C137.633018,67.5 138.090909,67.0421094 138.090909,66.4772727 C138.090909,65.9124361 137.633018,65.4545455 137.068182,65.4545455 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M104.156818,105.504545 C104.204595,104.934811 104.011741,104.371084 103.625,103.95 C103.234657,103.529085 102.685404,103.29157 102.111364,103.295408 L96.3431818,103.295408 C95.7691414,103.29157 95.2198887,103.529085 94.8295455,103.95 C94.4428043,104.371084 94.2499503,104.934811 94.2977273,105.504545 L95.1363636,115.568182 L103.318182,115.568182 L104.156818,105.504545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="104.340909"
            y="56.25"
            width="24.5454545"
            height="20.4545455"
            rx="4.09090909" />
          <rect
            id="Rectangle"
            class="fill-light"
            fill-rule="nonzero"
            x="108.431818"
            y="60.3409091"
            width="16.3636364"
            height="12.2727273"
            rx="2.04545455" />
          <path
            id="Path"
            d="M109.638636,72.4295455 L121.727273,60.3409091 L110.477273,60.3409091 C109.347599,60.3409091 108.431818,61.2566903 108.431818,62.3863636 L108.431818,70.5681818 C108.433495,71.3718397 108.905629,72.1000467 109.638636,72.4295455 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="108.431818"
            y="60.3409091"
            width="16.3636364"
            height="12.2727273"
            rx="2.04545455" />
          <rect
            id="Rectangle"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="112.522727"
            y="76.7045455"
            width="8.18181818"
            height="4.09090909" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="104.340909"
            y="35.7954545"
            width="24.5454545"
            height="20.4545455"
            rx="4.09090909" />
          <rect
            id="Rectangle"
            class="fill-light"
            fill-rule="nonzero"
            x="108.431818"
            y="39.8863636"
            width="16.3636364"
            height="12.2727273"
            rx="2.04545455" />
          <path
            id="Path"
            d="M109.638636,51.975 L121.727273,39.8863636 L110.477273,39.8863636 C109.347599,39.8863636 108.431818,40.8021448 108.431818,41.9318182 L108.431818,50.1136364 C108.433495,50.9172943 108.905629,51.6455013 109.638636,51.975 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="108.431818"
            y="39.8863636"
            width="16.3636364"
            height="12.2727273"
            rx="2.04545455" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="83.8863636"
            y="72.6136364"
            width="16.3636364"
            height="8.18181818"
            rx="2.04545455" />
          <line
            id="Path"
            x1="87.9772727"
            y1="76.7045455"
            x2="92.0681818"
            y2="76.7045455"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M96.1590909,75.6818182 C95.5942542,75.6818182 95.1363636,76.1397088 95.1363636,76.7045455 C95.1363636,77.2693821 95.5942542,77.7272727 96.1590909,77.7272727 C96.7239276,77.7272727 97.1818182,77.2693821 97.1818182,76.7045455 C97.1818182,76.1397088 96.7239276,75.6818182 96.1590909,75.6818182 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="83.8863636"
            y="64.4318182"
            width="16.3636364"
            height="8.18181818"
            rx="2.04545455" />
          <line
            id="Path"
            x1="87.9772727"
            y1="68.5227273"
            x2="92.0681818"
            y2="68.5227273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M96.1590909,67.5 C95.5942542,67.5 95.1363636,67.9578906 95.1363636,68.5227273 C95.1363636,69.0875639 95.5942542,69.5454545 96.1590909,69.5454545 C96.7239276,69.5454545 97.1818182,69.0875639 97.1818182,68.5227273 C97.1818182,67.9578906 96.7239276,67.5 96.1590909,67.5 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M89.2863636,46.8613636 C88.4272727,50.2363636 92.8045455,49.6431818 91.3318182,53.7136364 C92.3463845,51.8848292 93.2414396,49.9922317 94.0113636,48.0477273 C94.2148979,46.7889406 93.4206659,45.5839452 92.1836029,45.2746794 C90.9465399,44.9654137 89.6786903,45.6548887 89.2659091,46.8613636 L89.2863636,46.8613636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M96.1590909,58.2954545 C96.1590909,61.1181818 95.1363636,64.4318182 91.0454545,64.4318182 C86.9545455,64.4318182 85.9318182,61.1181818 85.9318182,58.2954545 L96.1590909,58.2954545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M99.2272727,61.3636364 C99.2272727,59.6691263 97.8536009,58.2954545 96.1590909,58.2954545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <ellipse
            id="Oval"
            class="fill-extra-light"
            fill-rule="nonzero"
            cx="53.2045455"
            cy="144.756818"
            rx="23.5227273"
            ry="3.53863636" />
          <polygon
            id="Path"
            class="fill-white"
            fill-rule="nonzero"
            points="40.2772727 100.063636 44.9818182 143.590909 61.4272727 143.590909 66.1522727 100.063636" />
          <polygon
            id="Path"
            class="fill-light"
            fill-rule="nonzero"
            points="62.8386364 130.663636 66.1522727 100.063636 40.2772727 100.063636 43.5704545 130.663636" />
          <line
            id="Path"
            x1="53.2045455"
            y1="109.472727"
            x2="53.2045455"
            y2="143.590909"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="43.5704545"
            y1="130.663636"
            x2="62.8386364"
            y2="130.663636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <polygon
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="40.2772727 100.063636 44.9818182 143.590909 61.4272727 143.590909 66.1522727 100.063636" />
          <path
            id="Path"
            d="M65.5181818,143.59091 C66.3569003,143.591785 67.132638,143.146017 67.5541952,142.420938 C67.9757525,141.695859 67.9793497,140.801172 67.5636364,140.072727 C64.1068182,134.059091 53.2454545,135.981818 53.2454545,143.59091 L65.5181818,143.59091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M53.2045455,143.590909 C53.2045455,135.838636 42.3431818,134.018182 38.8863636,140.072727 C38.4567431,140.799437 38.4534564,141.701602 38.8777708,142.431423 C39.3020851,143.161244 40.0877271,143.604729 40.9318182,143.590909 L53.2045455,143.590909 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M74.375,77.7272727 C74.375,66.0351537 64.8966645,56.5568186 53.2045455,56.5568186 C41.5124264,56.5568186 32.0340909,66.0351537 32.0340909,77.7272727 L32.0340909,82.4318182 L40.2159091,82.4318182 L40.2159091,100.063636 L66.1318182,100.063636 L66.1318182,82.4318182 L74.3136364,82.4318182 L74.375,77.7272727 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M74.375,77.7272727 C74.375,66.0351537 64.8966645,56.5568186 53.2045455,56.5568186 C41.5124264,56.5568186 32.0340909,66.0351537 32.0340909,77.7272727 L32.0340909,82.4318182 L40.2159091,82.4318182 L40.2159091,100.063636 L66.1318182,100.063636 L66.1318182,82.4318182 L74.3136364,82.4318182 L74.375,77.7272727 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="40.2568182"
            y1="82.4318182"
            x2="40.2568182"
            y2="73.0227273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="66.1318182"
            y1="82.4318182"
            x2="66.1318182"
            y2="73.0227273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M40.2568182,106.547727 C40.2568182,108.807074 38.4252558,110.638636 36.1659091,110.638636 C33.9065624,110.638636 32.075,108.807074 32.075,106.547727 L32.075,82.4318182 L40.2568182,82.4318182 L40.2568182,106.547727 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M40.2568182,106.547727 C40.2568182,108.807074 38.4252558,110.638636 36.1659091,110.638636 C33.9065624,110.638636 32.075,108.807074 32.075,106.547727 L32.075,82.4318182 L40.2568182,82.4318182 L40.2568182,106.547727 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M74.375,106.547727 C74.375,108.807074 72.5434376,110.638636 70.2840909,110.638636 C68.0247442,110.638636 66.1931818,108.807074 66.1931818,106.547727 L66.1931818,82.4318182 L74.375,82.4318182 L74.375,106.547727 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M74.375,106.547727 C74.375,108.807074 72.5434376,110.638636 70.2840909,110.638636 C68.0247442,110.638636 66.1931818,108.807074 66.1931818,106.547727 L66.1931818,82.4318182 L74.375,82.4318182 L74.375,106.547727 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M53.2045455,63.6136364 C56.6387996,63.6111928 59.5695892,61.1299639 60.1386364,57.7431818 C55.651142,56.1618598 50.7579489,56.1618598 46.2704545,57.7431818 C46.8395018,61.1299639 49.7702913,63.6111928 53.2045455,63.6136364 L53.2045455,63.6136364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M36.7386364,37.7386364 C36.7523512,36.3583056 37.7356799,35.1783112 39.0909091,34.9159091 L39.0909091,33.0340909 C39.0909091,25.2393448 45.4097993,18.9204545 53.2045455,18.9204545 C60.9992916,18.9204545 67.3181818,25.2393448 67.3181818,33.0340909 L67.3181818,34.9159091 C68.7334317,35.1841444 69.7337715,36.4554578 69.6615819,37.8940929 C69.5893924,39.332728 68.466811,40.4975149 67.0318182,40.6227273 C65.6480998,47.155003 59.8817681,51.8278158 53.2045455,51.8278158 C46.5273228,51.8278158 40.7609911,47.155003 39.3772727,40.6227273 C37.8901527,40.476496 36.7523633,39.2328657 36.7386364,37.7386364 L36.7386364,37.7386364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M56.7431818,43.7318182 C54.5952543,45.1434182 51.8138366,45.1434182 49.6659091,43.7318182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M49.6659091,24.7909091 C49.6659091,24.7909091 56.7431818,31.8681818 64.9659091,31.8681818 L64.9659091,50.6659091 C64.9560473,53.2238968 62.920479,55.3137469 60.3636364,55.3909091 C60.5473272,58.5041862 63.1256266,60.9348437 66.2443182,60.9348437 C69.3630097,60.9348437 71.9413091,58.5041862 72.125,55.3909091 L72.125,34.2204545 C72.125,23.8274597 63.699813,15.4022727 53.3068182,15.4022727 C42.9138233,15.4022727 34.4886364,23.8274597 34.4886364,34.2204545 L34.4886364,54.2045455 C34.4558354,56.0777749 35.1714434,57.8867386 36.476883,59.2305734 C37.7823225,60.5744083 39.5697885,61.3421384 41.4431818,61.3636364 C44.6853443,61.3636364 47.3136364,58.7353443 47.3136364,55.4931818 C46.0623613,55.4931936 44.8626314,54.9947308 43.9797677,54.1080285 C43.0969039,53.2213262 42.6036506,52.0194451 42.6090909,50.7681818 L42.6090909,31.8681818 L49.6659091,24.7909091 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M49.6659091,24.7909091 C49.6659091,24.7909091 56.7431818,31.8681818 64.9659091,31.8681818 L64.9659091,50.6659091 C64.9560473,53.2238968 62.920479,55.3137469 60.3636364,55.3909091 C60.5473272,58.5041862 63.1256266,60.9348437 66.2443182,60.9348437 C69.3630097,60.9348437 71.9413091,58.5041862 72.125,55.3909091 L72.125,34.2204545 C72.125,23.8274597 63.699813,15.4022727 53.3068182,15.4022727 C42.9138233,15.4022727 34.4886364,23.8274597 34.4886364,34.2204545 L34.4886364,54.2045455 C34.4558354,56.0777749 35.1714434,57.8867386 36.476883,59.2305734 C37.7823225,60.5744083 39.5697885,61.3421384 41.4431818,61.3636364 C44.6853443,61.3636364 47.3136364,58.7353443 47.3136364,55.4931818 C46.0623613,55.4931936 44.8626314,54.9947308 43.9797677,54.1080285 C43.0969039,53.2213262 42.6036506,52.0194451 42.6090909,50.7681818 L42.6090909,31.8681818 L49.6659091,24.7909091 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="46.3931818"
            cy="36.5727273"
            r="4.70454545" />
          <path
            id="Path"
            d="M43.0590909,39.8863636 C41.3485389,38.0306508 41.4070237,35.1557871 43.1916327,33.3711781 C44.9762416,31.5865691 47.8511054,31.5280843 49.7068182,33.2386364 L43.0590909,39.8863636 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="60.5068182"
            cy="36.5727273"
            r="4.70454545" />
          <path
            id="Path"
            d="M57.1727273,39.8863636 C55.4621752,38.0306508 55.52066,35.1557871 57.305269,33.3711781 C59.089878,31.5865691 61.9647417,31.5280843 63.8204545,33.2386364 L57.1727273,39.8863636 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M51.0977273,36.5727273 C51.0977273,35.2736029 52.1508756,34.2204545 53.45,34.2204545 C54.7491244,34.2204545 55.8022727,35.2736029 55.8022727,36.5727273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="46.3931818"
            cy="36.5727273"
            r="4.70454545" />
          <circle
            id="Oval"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="60.5068182"
            cy="36.5727273"
            r="4.70454545" />
          <circle
            id="Oval"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="53.2045455"
            cy="10.6977273"
            r="3.53863636" />
          <path
            id="Path"
            d="M36.7386364,28.3295455 C36.7386364,19.235675 44.110675,11.8636364 53.2045455,11.8636364 C62.2984159,11.8636364 69.6704545,19.235675 69.6704545,28.3295455 L69.6704545,30.6818182 L36.7386364,30.6818182 L36.7386364,28.3295455 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M36.7386364,30.6818182 C36.7386364,30.6818182 41.4431818,25.9772727 53.2045455,25.9772727 C64.9659091,25.9772727 69.5681818,30.6818182 69.5681818,30.6818182 C64.1373543,31.355227 58.6757137,31.7511959 53.2045455,31.8681818 C47.6992275,31.7546808 42.2033625,31.3587054 36.7386364,30.6818182 L36.7386364,30.6818182 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Shape"
            d="M53.2045455,18.6136364 C53.3739965,18.6136364 53.5113636,18.7510035 53.5113636,18.9204545 C53.5113636,19.0899055 53.3739965,19.2272727 53.2045455,19.2272727 C53.0350945,19.2272727 52.8977273,19.0899055 52.8977273,18.9204545 C52.8977273,18.7510035 53.0350945,18.6136364 53.2045455,18.6136364 M53.2045455,16.5681818 C51.9054211,16.5681818 50.8522727,17.6213302 50.8522727,18.9204545 C50.8522727,20.2195789 51.9054211,21.2727273 53.2045455,21.2727273 C54.5036698,21.2727273 55.5568182,20.2195789 55.5568182,18.9204545 C55.5623298,18.2949197 55.3162721,17.6934022 54.873935,17.251065 C54.4315978,16.8087279 53.8300803,16.5626702 53.2045455,16.5681818 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M47.3340909,19.5340909 C46.2946612,20.236357 45.3932959,21.1238551 44.675,22.1522727"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M59.075,19.5340909 C60.1144297,20.236357 61.015795,21.1238551 61.7340909,22.1522727"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
